import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000, // 120 seconds (2 minutes) - increased for AI model responses
  headers: {
    "Content-Type": "application/json",
  },
});

export const fetchData = async (endpoint) => {
  const response = await api.get(endpoint);
  return response.data;
};

export const postData = async (endpoint, data, headers = {}) => {
  const response = await api.post(endpoint, data, { headers });
  return response.data;
};

export const putData = async (endpoint, data) => {
  const response = await api.put(endpoint, data);
  return response.data;
};

export default api;
